import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Following';

const FollowingApi: any = baseApi(endpoint);

export default FollowingApi;